import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN = '[BenutzerverwaltungModul] PostBenutzerEntraTelefoneSichtbarAdmin laden';
export const POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerEntraTelefoneSichtbarAdmin ausführen';
export const POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerEntraTelefoneSichtbarAdmin laden erfolgreich';
export const POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerEntraTelefoneSichtbarAdmin Ladefehler';
export const POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerEntraTelefoneSichtbarAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerEntraTelefoneSichtbarAdminAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN;
        constructor(public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraTelefoneSichtbarAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_AUSFUEHREN;
        constructor(public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraTelefoneSichtbarAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraTelefoneSichtbarAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerTelefoneSichtbarkeitRequest: api.BenutzerTelefoneSichtbarkeitRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEntraTelefoneSichtbarAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_ENTRA_TELEFONE_SICHTBAR_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerEntraTelefoneSichtbarAdminActions =
    PostBenutzerEntraTelefoneSichtbarAdminAction
    | PostBenutzerEntraTelefoneSichtbarAdminAusfuehrenAction
    | PostBenutzerEntraTelefoneSichtbarAdminErfolgreichAction
    | PostBenutzerEntraTelefoneSichtbarAdminFehlerAction
    | PostBenutzerEntraTelefoneSichtbarAdminNichtAusgefuehrtAction
    ;
